// Profile-scoped localStorage key for the Copy Blogs → Add Blog Post handoff
// queue. Centralized here so the writer (CopyBlogs.jsx) and the reader
// (AddBlogPost.jsx) always agree on how a profile maps to a key, keeping
// articles saved under one language profile from leaking into another.
export const getCopyBlogsQueueKey = (profileId) =>
  `addpost_copyblogs_queue_${profileId || 'none'}`;
